// extracted by mini-css-extract-plugin
export default {"favicon":"favicon_IXB6H","box":"box_ANmCZ"};